import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  allResources,
  getDocument,
  mapConnection,
  mapDeal,
  Resource,
} from '../../services/portal';

export const fetchDeal = createAsyncThunk<
  Deal,
  { loanerId: string; dealId: string }
>('dealdetails/fetchDeal', async ({ dealId }) => {
  const [doc, connections] = await Promise.all([
    getDocument(
      `/deals/${dealId}/`,
      new URLSearchParams({
        include: 'customer,location,loan_officer,hubspot_dealstage',
      }),
    ),
    allResources(
      `/deals/${dealId}/connections/`,
      new URLSearchParams({ include: 'agent,stage' }),
    ),
  ]);
  return {
    ...mapDeal(doc.data as Resource, doc.included),
    connections: connections.resources.map((r) =>
      mapConnection(r, connections.included),
    ),
  };
});
export const fetchUpdates = createAsyncThunk<UpdateResults, string>(
  'dealdetails/fetchUpdates',
  async (dealId, { getState }) => {
    const { dealdetails } = getState() as { dealdetails: DealDetailsState };
    const doc = await getDocument(
      `/deals/${dealId}/updates/`,
      new URLSearchParams({
        'page[number]': String(dealdetails.page),
        'page[size]': '10',
        'filter[is_approved]': 'true',
        include: 'agent',
      }),
    );
    return {
      count: doc.meta!.pagination.count,
      results: (doc.data as Resource[]).map((r) => {
        const ref = r.relationships?.agent?.data as Resource;
        const agent = doc.included?.find(
          (item) => item.type === ref?.type && item.id === ref?.id,
        );
        return {
          ...r.attributes,
          id: r.id,
          status: r.attributes?.loan_officer_dealstage_name,
          agent: agent?.attributes,
        } as unknown as DealUpdate;
      }),
    };
  },
);
